<template>
  <div class="operation-timeline">
    <div
      v-for="(item, index) in normalizedItems"
      :key="`${getItemLabel(item)}-${index}`"
      class="operation-timeline__row"
    >
      <div class="operation-timeline__label">
        {{ getItemType(item, index) }}
      </div>
      <div class="operation-timeline__value">
        {{ getItemLabel(item) }}
      </div>
      <div class="operation-timeline__status">
        <v-chip x-small outlined :color="getItemColor(item)">
          {{ getItemStatus(item) }}
        </v-chip>
      </div>
    </div>
    <div v-if="normalizedItems.length === 0" class="text--secondary py-2">
      Aksiyon bulunmuyor.
    </div>
  </div>
</template>

<script>
import {
  formatOperationActionStatus,
  formatOperationActionText,
  formatOperationActionType,
} from "./operationActionLabels";

export default {
  name: "OperationTimeline",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    defaultStatus: {
      type: String,
      default: "Kontrol",
    },
    defaultColor: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    normalizedItems() {
      return this.items || [];
    },
  },
  methods: {
    getItemType(item, index) {
      return formatOperationActionType(item?.type, `Aksiyon ${index + 1}`);
    },
    getItemLabel(item) {
      return formatOperationActionText(
        item?.label || item?.message || formatOperationActionType(item?.type),
        "-"
      );
    },
    getItemStatus(item) {
      return (
        item?.status_label ||
        formatOperationActionStatus(item?.status, this.defaultStatus)
      );
    },
    getItemColor(item) {
      if (item?.status_color) {
        return item.status_color;
      }

      if (item?.status === "blocked") {
        return "error";
      }

      if (item?.status === "warning") {
        return "warning";
      }

      if (item?.status === "safe" || item?.can_apply === true) {
        return "success";
      }

      return this.defaultColor;
    },
  },
};
</script>

<style scoped>
.operation-timeline {
  display: grid;
  gap: 10px;
}

.operation-timeline__row {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: grid;
  gap: 14px;
  grid-template-columns: 160px minmax(0, 1fr) 150px;
  padding: 13px 14px;
}

.operation-timeline__label {
  color: #8d8d8d;
  font-size: 12px;
  font-weight: 700;
}

.operation-timeline__value {
  color: #2b2b2b;
  font-size: 14px;
  font-weight: 700;
  min-width: 0;
}

.operation-timeline__status {
  text-align: right;
}

@media (max-width: 960px) {
  .operation-timeline__row {
    grid-template-columns: 1fr;
  }

  .operation-timeline__status {
    text-align: left;
  }
}
</style>
